import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TextWidgetRenderer({ widget, variant, }) {
    if (!widget.config.title && !widget.config.description)
        return null;
    if (variant === 'editor') {
        return (_jsxs("div", { className: "text-sm text-muted whitespace-nowrap overflow-hidden", children: [_jsx("div", { children: widget.config.title }), _jsx("div", { className: "overflow-hidden overflow-ellipsis", children: widget.config.description })] }));
    }
    return (_jsxs("div", { className: "text-center mb-30", children: [_jsx("div", { className: "text-base font-medium", children: widget.config.title }), _jsx("div", { className: "text-sm mt-8", children: widget.config.description })] }));
}
